import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLDocumentTable } from 'ml-components-common-react';
import { MLTagManagerService } from 'ml-portals-services-react';
import { useModal } from '@jutro/components';
import { FormModalPopover } from 'ml-components-platform-react';

import MLClaimDetailsUploadDocumentPopup from '../MLClaimDetailsUploadDocumentPopup/MLClaimDetailsUploadDocumentPopup';

import metadata from './MLClaimDetailsDocsSent.metadata.json5';
import './MLClaimDetailsDocsSent.messages';

function MLClaimDetailsDocsSent(props) {
    const modalApi = useModal();
    const {
        claim,
        refreshData
    } = props;

    const openDocumentUploadingModal = () => {
        const componentProps = {
            showHeader: false,
            overrideProps: {
                claim
            },
            onSaveAction: (newDoc) => {
                if(newDoc){
                    claim.documentsYouSentUs_ML.push(newDoc)
                    refreshData();
                    return true;
                }
                return false;
            },
            CustomComponent: MLClaimDetailsUploadDocumentPopup
        };

        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_Upload Documents`);
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        )
    }

    const overrides = {
        documentTable: {
            documents: claim?.documentsYouSentUs_ML
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
            MLDocumentTable
        },
        resolveCallbackMap: {
            openDocumentUploadingModal
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsDocsSent;
